module.exports = __webpack_public_path__ + "img/imageYWY.23d0dbb3.png";